import { z } from "zod";
import { FirestoreTimestampSchema } from "./firestore.js";
const AuthorSchema = z.object({
  /** uid **/
  id: z.string(),
  createdAt: FirestoreTimestampSchema.optional().nullable(),
  name: z.string().optional().nullable(),
  email: z.string().email().nullable(),
  profileImage: z.string().optional().nullable()
});
const SenderRole = z.enum(["agent", "customer", "bot", "system"]);
export {
  AuthorSchema,
  SenderRole
};
//# sourceMappingURL=message.js.map